import $ from "jquery";

const MenuIcon = (el) => {
    const $el = $(el);
    const $arrowSvg = $(".js-menu-icon").html();
    const $button = $(".submenu__button-icon");

    $el.on("mouseenter", function () {
        const $icon = $el.next(".submenu-list__icon");

        $button.addClass("submenu__button-icon--active");

        if ($icon.length > 0) {
            const $iconSvg = $icon.html();
            $(".js-menu-icon").html($iconSvg);
            $button.removeClass("submenu__button-icon--arrow");
        } else {
            $(".js-menu-icon").html($arrowSvg);
            $button.addClass("submenu__button-icon--arrow");
        }
    });

    $el.on("mouseleave", function () {
        $(".js-menu-icon").html($arrowSvg);
        $button.addClass("submenu__button-icon--arrow");
        $button.removeClass("submenu__button-icon--active");
    });
};

export default MenuIcon;
